import {
  MIME_TYPE,
  IMAGE_TYPE,
  VIDEO_TYPE,
  AUDIO_TYPE,
  INDUSTRY_TYPE,
  PUBLISH_STATUES,
  POLICY_TYPE,
  NEWS_TYPE,
  SUPPLY_DEMAN_TYPE,
  DOCKING_STATUS,
  ACHIEVEMENT_MATURITY,
  TRANSFER_METHOD,
  TRANSFORMATION_STATUS,
  TRAINING_PRACTICE_TYPE,
  APP_TYPE,
  ENTERPRISE_TYPE,
  SEX_TYPE,
  ACCOUNT_TYPE,
  ACCOUNT_AUDIT_STATUS,
  PERSONAL_ID_TYPE,
  ENTERPRISE_ORGANIZAION_TYPE,
  ENTERPRISE_ID_TYPE,
  ADMIN_PUBLISH_STATUES,
  PUBLISH_AUDIT_STATUS,
  CHANNEL_TYPE,
  CHANNEL_AUDIT_TYPE,
} from "@/dictionary/index";
import { isEmpty } from "@/utils/type";

/**
 * 媒体类型
 */
export function mimeTypeFilter(str, showOther = true) {
  let val = str.toUpperCase();
  if (isEmpty(val)) return "";
  if (isImage(val)) return MIME_TYPE[0].value;
  if (isAudio(val)) return MIME_TYPE[1].value;
  if (isVideo(val)) return MIME_TYPE[2].value;
  return showOther ? MIME_TYPE[3].value : val;
}

export function isImage(val) {
  if (isEmpty(val)) return false;
  return IMAGE_TYPE.includes(val);
}

export function isAudio(val) {
  if (isEmpty(val)) return false;
  return AUDIO_TYPE.includes(val);
}

export function isVideo(val) {
  if (isEmpty(val)) return false;
  return VIDEO_TYPE.includes(val);
}

/**
 * 字典数据查询
 * @param {Array} arr 要查询的字典数组
 * @param {String|Number} originVal 查询值
 * @param {String|Number} tarKey 返回属性
 * @param {String|Number} originKey 查询属性
 * @param {any} emptyReturn 如果没有查到要返回的值
 */
export function filterLabelValue(arr, originVal, tarKey = "label", originKey = "value", emptyReturn = "") {
  isEmpty(tarKey) && (tarKey = "label");
  isEmpty(originKey) && (originKey = "value");
  if (isEmpty(originVal)) {
    return emptyReturn;
  } else {
    const obj = arr.find(item => item[originKey] == originVal);
    if (obj && Object.hasOwnProperty.call(obj, tarKey)) {
      return obj[tarKey];
    } else {
      return emptyReturn;
    }
  }
}

/**
 * 产业类型/技术领域
 */
export function filterIndustryType() {
  return filterLabelValue(INDUSTRY_TYPE, ...arguments);
}

/**
 * 发布状态
 */
export function filterPublishStatus(val, valueKey) {
  return filterLabelValue(PUBLISH_STATUES, val, "label", valueKey);
}

/**
 * 政策类型
 */
export function filterPolicyType() {
  return filterLabelValue(POLICY_TYPE, ...arguments);
}

/**
 * 新闻类型
 */
export function filterNewsType() {
  return filterLabelValue(NEWS_TYPE, ...arguments);
}

/**
 * 培训实训类型
 */
export function filterTrainingPracticeType() {
  return filterLabelValue(TRAINING_PRACTICE_TYPE, ...arguments);
}

/**
 * 应用类型
 */
export function filterAppType() {
  return filterLabelValue(APP_TYPE, ...arguments);
}

/**
 * 供需类型
 */
export function filterSupplyDemanType() {
  return filterLabelValue(SUPPLY_DEMAN_TYPE, ...arguments);
}

/**
 * 对接状态
 */
export function filterDockingStatus() {
  return filterLabelValue(DOCKING_STATUS, ...arguments);
}

/**
 * 成果成熟度
 */
export function filterAchievementMaturity() {
  return filterLabelValue(ACHIEVEMENT_MATURITY, ...arguments);
}

/**
 * 转让方式
 */
export function filterTransferMethod() {
  return filterLabelValue(TRANSFER_METHOD, ...arguments);
}

/**
 * 转化状态
 */
export function filterTransformationStatus() {
  return filterLabelValue(TRANSFORMATION_STATUS, ...arguments);
}

/**
 * 企业类别
 */
export function filterEnterpriseType() {
  return filterLabelValue(ENTERPRISE_TYPE, ...arguments);
}

/**
 * 性别
 */
export function filterSexType() {
  return filterLabelValue(SEX_TYPE, ...arguments);
}

/**
 * 账户类型
 */
export function filterAccountType() {
  return filterLabelValue(ACCOUNT_TYPE, ...arguments);
}

/**
 * 账户认证/审核状态
 */
export function filterAccountAuditStatus() {
  return filterLabelValue(ACCOUNT_AUDIT_STATUS, ...arguments);
}

/**
 * 发布审核状态
 */
export function filterPublishAuditStatus() {
  return filterLabelValue(PUBLISH_AUDIT_STATUS, ...arguments);
}

/**
 * 个人证件类型
 */
export function filterIDType() {
  return filterLabelValue(PERSONAL_ID_TYPE, ...arguments);
}

/**
 * 企业证件类型
 */
export function filterEnterpriseIDType() {
  return filterLabelValue(ENTERPRISE_ID_TYPE, ...arguments);
}

/**
 * 企业类型
 */
export function filterEnterpriseOrganizationType() {
  return filterLabelValue(ENTERPRISE_ORGANIZAION_TYPE, ...arguments);
}

/**
 * 发布状态(Admin)
 */
export function filterAdminPublishStatus() {
  return filterLabelValue(ADMIN_PUBLISH_STATUES, ...arguments);
}

/**
 * 申报方式
 */
export function filterChannelType() {
  return filterLabelValue(CHANNEL_TYPE, ...arguments);
}

/**
 * 申报状态
 */
export function filterChannelAuditType() {
  return filterLabelValue(CHANNEL_AUDIT_TYPE, ...arguments);
}

/**
 * 支付类型
 */
export function filterPayType() {
  return filterLabelValue(PAY_TYPE, ...arguments);
}
